import { SemicolonSerializer } from '../serializer/Serializer';
import { CourseCompletionStatus, IPersistenceTrackingClient, PersistenceTrackingData } from '../trackingClient';
import { iOSNotificationFunction } from './mobileAppIntegration';
import { TrackedData } from './trackedData';

export class OfflineClient implements IPersistenceTrackingClient {
  constructor(
    private readonly _tracking: TrackedData,
    private readonly _onTrackedDataChange: iOSNotificationFunction
  ) {}

  name = 'v360eMobileClient';
  doesSupportLegacyData = true;

  init = (): Promise<boolean> => {
    return Promise.resolve(true);
  };

  setTrackingData = ({
    finishedItems,
    widgetTrackingData,
    openQuestionAnswers,
  }: PersistenceTrackingData): Promise<void> => {
    const payload = SemicolonSerializer.serializeData(finishedItems, widgetTrackingData, openQuestionAnswers);

    this._tracking.updateTrackingLog(payload);
    this._onTrackedDataChange(this._tracking);

    return Promise.resolve();
  };

  afterSetup(): Promise<void> {
    return Promise.resolve(undefined);
  }

  getTrackingData = (): Promise<PersistenceTrackingData> => {
    const result = SemicolonSerializer.deserializeData(this._tracking.getLog());
    return Promise.resolve(result);
  };

  setCompletionStatus = (status: CourseCompletionStatus): Promise<void> => {
    if (this._tracking.setCompletionStatus(status)) {
      this._onTrackedDataChange(this._tracking);
    }

    return Promise.resolve();
  };

  setQuizStatus = (): Promise<void> => {
    return Promise.resolve();
  };

  // No need for unique learner ID when offline
  getLearnerId = () => 'offline';
}
